import React, { useState } from "react";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import Moment from "moment";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    cancelFn: (refreshData?: boolean) => void;
    startFn: (startTime: string) => void;
};

export const QboPullInvoicesAsOrdersModal = (props: Props) => {
    const [selectedDate, setSelectedDate] = useState<Moment.Moment | null | undefined>();

    const start = () => {
        if (selectedDate) {
            props.startFn(selectedDate.format("YYYY-MM-DD"));
            props.cancelFn(false);
        }
    };

    return (
        <div className={"QboPullInvoicesAsOrdersModal p-3"}>
            <div className={"text-end"}>
                <OwButton
                    className={"btn-danger"}
                    centerIconClass={"fas fa-times"}
                    fn={() => {
                        props.cancelFn(false);
                    }}
                />
            </div>
            <div>
                <OwTitle tag={"h5"} title={"start_date"} />
            </div>
            <div>
                <OwDateInput
                    fn={(date) => {
                        setSelectedDate(date);
                    }}
                />
            </div>
            <div>
                <OwButton title={"start"} fn={start} disabled={!selectedDate} />
            </div>
        </div>
    );
};
